import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BodyLeads() {
    return (
        <OnboardingBody
            title={
                <span>
                    Potential sales are <em>leads</em>
                </span>
            }
        >
            <div>
                <p>
                    <strong>Leads</strong> are connected to people and companies. <br />
                    They have a dollar value, an assigned rep, and can be won or lost.
                    <br />
                    <br />
                    Some call them opportunities, deals, or prospects. At Nutshell, we’ve chosen to
                    simplify. A lead is a lead, from first contact to sale.
                </p>
            </div>
        </OnboardingBody>
    );
}
